import React, { forwardRef, useContext } from "react";
import PropTypes from "prop-types";

import { TabsContext } from "./TabsContext";

const TabPanel = forwardRef(({ children, ...restProps }, forwardedRef) => {
  const { tabsId, childIndex, currentIndex } = useContext(TabsContext) || {};

  return (
    <div
      ref={forwardedRef}
      id={`${tabsId}_panel-${childIndex}`}
      role="tabpanel"
      aria-labelledby={`${tabsId}_tab-${childIndex}`}
      tabIndex="0"
      hidden={childIndex !== currentIndex}
      {...restProps}
    >
      {children}
    </div>
  );
});

TabPanel.displayName = "Tabs.Panel";

TabPanel.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default TabPanel;
